import { cn } from '@/lib/utils'
import { tagClassFor } from '@/lib/tag-colors'

interface TagChipProps {
  name: string
  color?: string | null | undefined
  className?: string
}

/**
 * Compact tag pill used in the library list and citation cards.
 *
 * Colors come from the 10-color palette in `@/lib/tag-colors`. Legacy
 * 'gray' values render as `slate` for consistent contrast.
 */
export function TagChip({ name, color, className }: TagChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center h-[18px] px-[7px] rounded-[5px]',
        'text-[10.5px] font-medium leading-none whitespace-nowrap tracking-[0.02em]',
        tagClassFor(color),
        className
      )}
    >
      {name}
    </span>
  )
}

interface TagOverflowChipProps {
  count: number
  className?: string
}

/**
 * "+N" overflow indicator shown when more tags exist than the inline limit.
 */
export function TagOverflowChip({ count, className }: TagOverflowChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center h-[18px] px-[7px] rounded-[5px]',
        'text-[10.5px] font-medium leading-none whitespace-nowrap',
        'bg-muted text-muted-foreground border border-border',
        className
      )}
    >
      +{count}
    </span>
  )
}
